import template from './lift-types.jade';
import { getLiftTypesByCategory } from '../../../enums/lift-types';
import validation from '../../../services/validation';

export default angular
    .module('cian.addForm.liftTypes', [])
    .directive('cianAfAboutBuildingLiftTypes', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['$scope', 'categoryService', 'deviceService', function($scope, categoryService, deviceService) {
            this.ad.building = this.ad.building || {};
            this.ad.building.liftTypes = this.ad.building.liftTypes || [];
            this.isMobile = deviceService.isMobile;

            const originalItems = getLiftTypesByCategory(this.ad.category);
            const items = originalItems.map((item, index) => {
                return {
                    ...item,
                    inputName: `building.liftTypes.${index}`
                }
            });

            this.items = items.map(originalItem => {
                const item = {...originalItem};
                const itemType = item.value;
                const itemInModel = this.ad.building.liftTypes.find(item => item.type === itemType) || this.ad.building.liftTypes.push({type: itemType}) && this.ad.building.liftTypes[this.ad.building.liftTypes.length - 1];
                Object.defineProperty(item, 'count', {
                    get() {
                        return itemInModel.count;
                    },
                    set(value) {
                        itemInModel.count = value;
                    }
                });

                item.validation = validation(this.form, item.inputName, {
                    parse: 'Введите число',
                    min: 'Введите число',
                    maxlength: 'Введите число',
                    max: 'Допустимо не более 2 символов',
                });

                return item;
            });

            this.minCount = 0;
            this.maxCount = 100;

            $scope.$watchGroup([() => this.ad.category, () => this.ad.placementType], ([category, placementType]) => {
                    if (!category) return;
                    const { objectType } = categoryService.getInfoByCategory(category);
                    this.enabled = objectType != 'shoppingArea' || placementType === 'shoppingMall';
                });
        }],
        controllerAs: 'liftTypes',
        template,
    }))
    .name;
